module.exports = __webpack_public_path__ + "img/teal-gigawhat.f6486ed5.svg";